var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChristmasSwirls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ae3142;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #eae487;\n      }\n\n      .cls-4 {\n        fill: #c90;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-161.11 -75.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    className: "cls-1",
    x: 161.11,
    y: 75.11,
    width: 350,
    height: 350
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 350,
    height: 350
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    width: 350,
    height: 350
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 350,
    height: 350
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338,121.31s2.78,1.72,4.4,1.06,2-1.13,3.72-3a14.84,14.84,0,0,1,3.67-3,11,11,0,0,1-3.82.91c-1,.09-1.34-.31-2.67-1s-1.49-.68-2-.38A17.85,17.85,0,0,0,339,118.7a9.85,9.85,0,0,1,2.51-1.33,1.4,1.4,0,0,1,1.58.94c.22.52.11,1-.54,1.55a1.78,1.78,0,0,1-1.89.51,7,7,0,0,1-2.19-1,8,8,0,0,1-1.51-1.85l.11-.08s3.22-.5,4-2.06.8-2.17.88-4.68a14.75,14.75,0,0,1,.84-4.68,11,11,0,0,1-2.32,3.17c-.67.7-1.21.64-2.68,1s-1.58.46-1.81,1a18.42,18.42,0,0,0,.06,3.66,9.81,9.81,0,0,1,1-2.65,1.43,1.43,0,0,1,1.82-.31c.5.25.73.69.59,1.53a1.77,1.77,0,0,1-1.1,1.61,7.11,7.11,0,0,1-2.29.71,8.3,8.3,0,0,1-2.35-.43l-.19,0s2.11-2.49,1.7-4.19-.81-2.17-2.39-4.12a15.11,15.11,0,0,1-2.43-4.08,10.79,10.79,0,0,1,.33,3.9c-.05,1-.5,1.28-1.4,2.49s-.9,1.38-.69,2a18.51,18.51,0,0,0,2.44,2.72,9.57,9.57,0,0,1-.94-2.68,1.4,1.4,0,0,1,1.17-1.42c.54-.14,1,0,1.44.77a1.76,1.76,0,0,1,.23,1.94,7.35,7.35,0,0,1-1.27,2,8.31,8.31,0,0,1-2.06,1.21l-.1.08s.05-3.26-1.36-4.31-2-1.16-4.46-1.66a14.53,14.53,0,0,1-4.47-1.61,10.73,10.73,0,0,1,2.73,2.82c.58.77.43,1.3.51,2.81s.18,1.63.72,2a18.15,18.15,0,0,0,3.62.56,9.86,9.86,0,0,1-2.44-1.48,1.43,1.43,0,0,1,0-1.84c.33-.45.81-.6,1.61-.32a1.75,1.75,0,0,1,1.4,1.35,7.26,7.26,0,0,1,.32,2.37,8.12,8.12,0,0,1-.82,2.25l.06.07s-2-2.55-3.79-2.47-2.29.38-4.5,1.56a14.74,14.74,0,0,1-4.47,1.6,10.86,10.86,0,0,1,3.89.43c.94.23,1.16.74,2.18,1.85s1.18,1.14,1.81,1a18.34,18.34,0,0,0,3.14-1.87,9.82,9.82,0,0,1-2.82.41,1.41,1.41,0,0,1-1.17-1.42c0-.56.24-1,1-1.27a1.78,1.78,0,0,1,1.95.15,7.3,7.3,0,0,1,1.75,1.63,8.17,8.17,0,0,1,.8,2.25V123s-3.2-.63-4.49.56-1.49,1.77-2.43,4.1a15,15,0,0,1-2.38,4.1,10.63,10.63,0,0,1,3.25-2.18c.87-.43,1.36-.19,2.86,0s1.64.11,2.06-.37a18.72,18.72,0,0,0,1.19-3.45A9.58,9.58,0,0,1,325,127.9a1.42,1.42,0,0,1-1.81-.33c-.38-.41-.45-.9,0-1.64a1.79,1.79,0,0,1,1.59-1.14,7.1,7.1,0,0,1,2.39.12,8.12,8.12,0,0,1,2.06,1.2l.06.08s-2.85,1.6-3.05,3.34,0,2.32.81,4.7a15.18,15.18,0,0,1,.86,4.67,10.94,10.94,0,0,1,1-3.78c.39-.89.92-1,2.18-1.85s1.32-1,1.33-1.61a18.31,18.31,0,0,0-1.34-3.4,9.7,9.7,0,0,1-.05,2.84,1.42,1.42,0,0,1-1.59.93c-.56-.06-.93-.39-1.09-1.23a1.77,1.77,0,0,1,.46-1.89,7.39,7.39,0,0,1,1.9-1.47,8.35,8.35,0,0,1,2.35-.42l.29,0s-1.19,3-.25,4.51,1.48,1.79,3.6,3.13a14.75,14.75,0,0,1,3.62,3.07,10.64,10.64,0,0,1-1.57-3.59c-.27-.93.06-1.37.52-2.81s.39-1.59,0-2.09a18.64,18.64,0,0,0-3.19-1.79,9.57,9.57,0,0,1,1.76,2.24,1.41,1.41,0,0,1-.64,1.72c-.47.31-1,.28-1.62-.26a1.77,1.77,0,0,1-.84-1.76,7.26,7.26,0,0,1,.54-2.33,8.42,8.42,0,0,1,1.56-1.82l.09-.16s1.1,3.07,2.78,3.57,2.29.38,4.77,0a14.88,14.88,0,0,1,4.74-.06,11,11,0,0,1-3.54-1.67c-.82-.53-.86-1.08-1.46-2.46s-.75-1.46-1.37-1.58a18.77,18.77,0,0,0-3.58.75,9.62,9.62,0,0,1,2.8.53,1.42,1.42,0,0,1,.65,1.72c-.15.54-.54.85-1.39.87a1.79,1.79,0,0,1-1.8-.77,7.54,7.54,0,0,1-1.12-2.12,8.27,8.27,0,0,1,0-2.39",
    transform: "translate(-161.11 -75.11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264,394.83s-2.56-.45-1.8-3.65,5-4.55,5-4.55a7.18,7.18,0,0,1,4.48.37s-.15-4.89,4.25-6.09,6.33,3.61,6.33,3.61a5,5,0,0,1-.83,4.07,3,3,0,0,1-3.39.75s-2-.94-1.58-2.86c0,0-.81,3.19,2.15,3.68,5,.84,7.19-3.23,7.71-6.58a18.57,18.57,0,0,0,0-6.33c-.33-1.69-1.69-6.62-1.69-6.62a16.79,16.79,0,0,1-.83-4.71,8.21,8.21,0,0,1-4.48,3.69,7.9,7.9,0,0,1-5,.12,8.3,8.3,0,0,1-3.94-2.64,4.79,4.79,0,0,1-.64-4.59,3,3,0,0,1,2.79-1.66c1.88.19,2.37.91,2.37.91a5.74,5.74,0,0,1,1,1.5,3.88,3.88,0,0,0,1.62,1.81c.67.37,2.78-.27,2.78-.27s2.73-1.37,4.63-5.62,2-5,4-8.21a15.36,15.36,0,0,1-8.1-4,13.74,13.74,0,0,1-4.15-7.17,12.49,12.49,0,0,1,.83-7.31,12.65,12.65,0,0,1,3.74-4.89,10.25,10.25,0,0,1,4.85-2.21c3.11-.58,6.45,1.61,6.45,1.61a8.29,8.29,0,0,1,3.86,5.47,7.66,7.66,0,0,1-1.48,5.82,7.94,7.94,0,0,1-3.59,2.86,6,6,0,0,1-4.34,0s-2.71-1.05-2.89-2.68a2.9,2.9,0,0,1,.63-2.39s1.05-1.23,2.11-1.13a3.57,3.57,0,0,1,2.33.65,2.1,2.1,0,0,0,.88-2.88c-.88-2-3.44-1.31-3.44-1.31a7.18,7.18,0,0,0-4.09,5.3c-.5,3.79,3.57,6.82,3.57,6.82a7.85,7.85,0,0,0,3.71,1.66,10.32,10.32,0,0,0,4.29-.88l1-.52s4.87-4.27,8.36-5.42,4.39-1.66,8.43-1.76a25,25,0,0,1,8.36,1.6l8,3.64s5.62,2.79,9.16,2.46,5.07-1.8,5.07-1.8a8.17,8.17,0,0,0,2.76-5.25c.32-3.34-1.21-4.62-1.21-4.62a4.74,4.74,0,0,0-3.69-2.08c-2.61-.2-3.31.6-4.19,1.43a3.23,3.23,0,0,0-.6,2.69,2.32,2.32,0,0,0,.78.75c.4.22,1.1.15,1.38,1.28a2.76,2.76,0,0,1-.2,2.41c-.45.93-2.18,1.08-2.18,1.08a6.64,6.64,0,0,1-4.42-4,8.09,8.09,0,0,1,4.36-9.51,10.61,10.61,0,0,1,8.51-.46,11.45,11.45,0,0,1,6,7.53s3.51-3.26,7.3-3,4.49,1.48,5.9,3,1.23,5.6.15,7-2,2.89-5,3-4.41-3.34-4.41-3.34-1.08-2.76.72-4.54,4.12-.16,4.12-.16a3.26,3.26,0,0,1,1,2.84s1.43-1.51-.53-3.51-6,.47-6.67,1a12.5,12.5,0,0,0-2.66,3.66,11.17,11.17,0,0,1-3,5.65,15.35,15.35,0,0,1-7.58,3.84c-1.83.45-6.2-.17-9.09-1.35a19.11,19.11,0,0,1,1.13,11.87,19.44,19.44,0,0,1-6.45,10.21,21,21,0,0,1-7.85,3.92,23.94,23.94,0,0,1,4.17,4.35c2.22,2.9,3,4,3,4s2.32,3.61,3.39,5.14a5.56,5.56,0,0,0,2.88,2.54A6.67,6.67,0,0,0,334,390a3.84,3.84,0,0,0,2.41-1.7,3.22,3.22,0,0,0,.17-3.25c-.28-.42-.54-.74-1-.77a2.75,2.75,0,0,1,.79,2.39,2.83,2.83,0,0,1-1.21,1.69,4.15,4.15,0,0,1-3.37.23c-1.95-.66-2.37-3.15-2.37-3.15s-.3-2.88,1.24-4.53a6.52,6.52,0,0,1,3.34-2,6.16,6.16,0,0,1,4.95,1.64,8,8,0,0,1,2.42,4.51,10.38,10.38,0,0,1-1.14,5.88,8.55,8.55,0,0,1-7.12,4,13.67,13.67,0,0,1-7.3-2.88,21.89,21.89,0,0,1-5.4-7,15.77,15.77,0,0,1-.32,4.73,7.32,7.32,0,0,1-3.19,4.62,5.26,5.26,0,0,1-3.34.57,5,5,0,0,1-3.09-1.9,6.06,6.06,0,0,1-.9-3.36,3.09,3.09,0,0,0,3.89.42,5.44,5.44,0,0,0,2.28-3.61,11.88,11.88,0,0,0-1.33-6.7,21.17,21.17,0,0,0-3.56-5.52,9.62,9.62,0,0,1,1.46,5.77c-.43,2.89-.46,2.71-.91,3.64a7.67,7.67,0,0,1-2.11,2.41c-.75.6-2.73.43-2.73.43s-1.73-.91-1.63-2.46a2.83,2.83,0,0,1,1.85-2.51,8.5,8.5,0,0,1,1.36-.2,2.7,2.7,0,0,0,1.71-2.29c.15-1.75-1.43-4.42-1.43-4.42a10,10,0,0,0-1.23-1.7,15.44,15.44,0,0,1-6.68-4.54c-2.81-3.39-2.63-8.56-2.63-8.56s.2-5.25,3.08-8.48a13.68,13.68,0,0,1,6.8-4,12.66,12.66,0,0,1,6.53.68,7.12,7.12,0,0,1,4.34,5.22,11.84,11.84,0,0,1-.73,5.9,3.57,3.57,0,0,1-5.67,1.63,3.32,3.32,0,0,1-1.1-2.44,7.79,7.79,0,0,1,1.38-3.86,3.44,3.44,0,0,0-2.51-1.63c-1.63-.1-3.42,1.53-3.87,2.15a6.89,6.89,0,0,0-1.08,6.53c1.18,3.51,3.17,4.77,6.78,5.77s8.26-1.55,10.11-3.76,3.47-5.55,3-8.76a11.22,11.22,0,0,0-3.41-7.25c-2.34-2.51-5.9-3.59-9.19-3.77a18.05,18.05,0,0,0-9.26,2.13c-2.06,1.28-5.87,3.27-7.88,6.2s-2.36,2.61-4.47,7.43-1.68,9-1,12.63a9.47,9.47,0,0,0,5,6.77c1.28.73,3.47.85,4.24.23a3.43,3.43,0,0,0,1.18-1.94s2,2.67.71,5a4.9,4.9,0,0,1-4,2.36,9.46,9.46,0,0,1-4.22-.86,11.32,11.32,0,0,1-2.68-1.93,14.93,14.93,0,0,1-.71,6.1,11.68,11.68,0,0,1-4.34,5.35,8.49,8.49,0,0,1-11.09-1.21,13.79,13.79,0,0,0-3.39-3c-1.18-.58-3.51-.16-3.86.35a2.36,2.36,0,0,0-.51,1.6,4,4,0,0,1,.15,2.24A2.07,2.07,0,0,1,264,394.83Z",
    transform: "translate(-161.11 -75.11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343,387.52a5.83,5.83,0,0,0,3.76,2.52,9.17,9.17,0,0,0,3.74-.16s4.92,4.57,9.82,4.44,7-1.38,9.16-4a10.54,10.54,0,0,0,2.26-9.22c-.73-3.71-4.4-6-4.4-6a7.61,7.61,0,0,0-5.94-1.13c-3.59.73-4.75,4.62-5.05,5.34s.33,2.74,1.76,2.94a2.25,2.25,0,0,0,2.36-.85,3.4,3.4,0,0,1,1.25-1.89,3.07,3.07,0,0,1,3.41-.05c1.23.76,1.51,2.16,1.39,3.64s-1.48,3-2.54,3.84a7.47,7.47,0,0,1-5.07,1.36,8.5,8.5,0,0,1-5.75-3.42c-2.13-2.53-2-6.8-1.1-8.9a10.42,10.42,0,0,1,6.25-5.75,11.78,11.78,0,0,1,8.05.2,17.38,17.38,0,0,1,7.28,5.8c1.87,2.46,3.39,5.09,5.85,6.9s4.14,1.8,6,3.34,1.55,3.18,1.13,3.68a2.29,2.29,0,0,1-1.38.73,2,2,0,0,0-1.33,2c.05,1.25,1.28,1.83,2.76,1.58s2.59-2.12,2.93-3.59c.23-.95-.47-3-1.88-4.36a24.5,24.5,0,0,0,6.83.2c4.31-.38,4.72.15,6.22,1.28a2.76,2.76,0,0,1,.65,3.69,2.09,2.09,0,0,1-2.46.52,2,2,0,0,0,2-1c.4-.7-.22-2.18-1.75-2.41a3,3,0,0,0-2.21,5.35,4.47,4.47,0,0,0,5,.15c2.33-1.2,2.33-3.86,2-5.29a5.9,5.9,0,0,0-2.81-3.54,6.88,6.88,0,0,0-3.81-1,6.14,6.14,0,0,0,2-3.76,2.48,2.48,0,0,0-1.88-2.76c-.56-.23-2.06.4-2.06.4s2,.6.8,2.76a5.85,5.85,0,0,1-4.36,3c-1.56.37-3.26.12-6-.93a17.6,17.6,0,0,1-6.78-5.65,11.94,11.94,0,0,1-2.34-6.42c-.25-3,1.46-6.28,3.34-7.18a7.35,7.35,0,0,1,5.77-.75,6.83,6.83,0,0,1,4.82,5.69,4.9,4.9,0,0,1-6.07,5.52s-2.28-.95-2.59-2.25c-.45-2,1.11-2.34,1.11-2.34a3.28,3.28,0,0,0,2.58,1c1.33-.27,1.48-1,1.66-1.83s-.9-1.83-1.93-2.18a6.09,6.09,0,0,0-4-.25c-1.5.53-2.81,2.63-2.81,4.84a7.24,7.24,0,0,0,3,5.65,9.61,9.61,0,0,0,7.2,1.18c2.69-.58,4.59-3.82,5-4.85a16.31,16.31,0,0,0,.66-3,5.62,5.62,0,0,1,1.28-.88,3.94,3.94,0,0,0,1.53-3.61s-.93,1.43-1.61,1.7a1.8,1.8,0,0,1-1.43-.17,11.94,11.94,0,0,0-3.59-5.75,11.75,11.75,0,0,0-7.3-2.69c-.95,0-4.49.63-6.25,2a12.4,12.4,0,0,0-3.79,5,14.11,14.11,0,0,0-.78,4.14s-1.88-.25-4.94-2.56a15.34,15.34,0,0,1-4.87-5.77,6.32,6.32,0,0,1,.05-4.59,16.25,16.25,0,0,1,2.74-3.82s-.63-2.48-2-3.34a3.52,3.52,0,0,0-3.86,0,6.71,6.71,0,0,0-2,2.89,6,6,0,0,0-.26,2.79,13.68,13.68,0,0,0-3.94-4.29,10.4,10.4,0,0,0-4.61-1.71,7.62,7.62,0,0,0-4.85,1.05,6.18,6.18,0,0,0-2.63,4.42,7.59,7.59,0,0,0,.8,3.76,5.67,5.67,0,0,0,3.34,2.54,4.14,4.14,0,0,0,4.92-5.35,3.4,3.4,0,0,0-2.31-2.13,2.5,2.5,0,0,0-2.49,1.08,2.7,2.7,0,0,0,.23,2.48,2.13,2.13,0,0,1-.95-2.48,2.86,2.86,0,0,1,2.91-2.13c1-.05,2.32.05,5.12,2.63a16.08,16.08,0,0,1,2.78,3.77s3,4.74,4.87,6a16.18,16.18,0,0,0-8.43,2.86c-3.46,2.31-5.33,6.35-6,10-.35,1.94.43,5.85,1.83,8.34,0,0-.07.9-1.4,1.45S343,387.52,343,387.52Z",
    transform: "translate(-161.11 -75.11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.66,188.13s-1.47,2.21-1,4a8.13,8.13,0,0,0,1.13,2.41,17.35,17.35,0,0,0-1.51,5.34,9.52,9.52,0,0,0,2.21,6.55,10.37,10.37,0,0,0,7.68,3.26c4,.11,6.68-3.21,7.5-5.19a6.43,6.43,0,0,0-.3-5.61c-.85-1.42-3-2.2-4.09-2.37a5.37,5.37,0,0,0-2.08.1,2.24,2.24,0,0,0-1.31,2.06,1.59,1.59,0,0,0,1.56,1.53,2.57,2.57,0,0,1,2.51,1.68c.48,1.33-.73,2.74-2.66,3.21a4.78,4.78,0,0,1-3.94-.85,5.5,5.5,0,0,1-2.21-3.79,6.84,6.84,0,0,1,1.66-5.4,9.71,9.71,0,0,1,4.89-2.73,8.26,8.26,0,0,1,6.15,1.35,8,8,0,0,1,3.51,7.28,12.78,12.78,0,0,1-2.38,6.5,13.38,13.38,0,0,1-3.77,3.19,40.81,40.81,0,0,0-8.15,8.48s-1.86-3.64-4.9-4.47a7.12,7.12,0,0,0-6.35,1.08,9.31,9.31,0,0,0-2.25,3.62c-.36,1.7.17,4.41,2,5.34a4.42,4.42,0,0,0,5-.32,3.66,3.66,0,0,0,1.23-4,3,3,0,0,0-2.48-2,2.08,2.08,0,0,0-2,2.36s-1.22-1.85,1.54-2.78,5,1.7,5.47,3.18a8.16,8.16,0,0,1-.28,5.5,39.35,39.35,0,0,0-3.34,11.42s-2.61-5.87-8.71-3.92c-3.91,1.26-3.91,5.7-2,6.28,1.71.51,2.12.45,3.64-.78.53-.43.77-1.95,3.19-1.63,1.73.22,3.86,3.59,4,6.8a23.14,23.14,0,0,0,4.77,11.24c3,3.79,8.86,10.09,8.86,18s-4.67,13.51-11.07,16.15-12.87-1.06-15.17-4.6-3.76-8.77-1.62-13.62,9.3-6.29,12.13-4.71a5,5,0,0,1,2.4,6.66c-1,2.41-4.14,2.53-4.14,2.53s-2.86.64-1.84,4,7.64,2.75,11.63-1.27,2.15-12.13-1.92-15.44a15.83,15.83,0,0,0-18.86-.64c-7.45,4.78-8.92,18.79-3.46,25.45s9.52,7.08,9.52,7.08-8.81-1-13.1,4.21c-3.27,4-1,11.48,3.54,13.55,3.25,1.48,8.33,2.1,10.65-2.74,2.15-4.48-2.22-8.85-4.93-8.62s-5,2.07-4.55,4.74,2.9,2.63,3.57,2.11c0,0-3.08,2.41-4.93-2.09-.58-1.4-.45-5.27,4.67-6.77a31.81,31.81,0,0,1,8-1.28c4.89-.38,7.08-1.13,9.66-2.46a45.5,45.5,0,0,0-4.39,9.51,40.72,40.72,0,0,0-1.69,8.28,37.19,37.19,0,0,0-.76,6c0,2.63-1.31,6.66-3.87,8.69a5.46,5.46,0,0,1-7.27-.67,6,6,0,0,1-1.43-5.27,4.47,4.47,0,0,1,3.24-3.35,3.58,3.58,0,0,1,4.14,1.74,3.19,3.19,0,0,1,.2,1.88,1.66,1.66,0,0,1-1,.89,1.56,1.56,0,0,1-1.32-.21c-.43-.29-.44-.64-.79-.74a1,1,0,0,0-.85.26,3.83,3.83,0,0,0-.65.73c-.29.49,0,1.12.06,1.27s2,2.52,4.58,1.5,2.91-3.92,2.86-5.12a6.21,6.21,0,0,0-2.33-4.26A6.74,6.74,0,0,0,304,316a6.87,6.87,0,0,0-4.19.93,8.81,8.81,0,0,0-3.18,4.08,5.61,5.61,0,0,0-2.52,1.19,4.75,4.75,0,0,0-.85,1.77s1.39-1.73,2.81-.64a10.08,10.08,0,0,0,2.22,7.74c3,3.42,8.26,3,10,2.22a11.32,11.32,0,0,0,4.88-4.46,16.25,16.25,0,0,0,1.46-4.3s2.75,4.45,6.29,5.14,5.7-.69,6.91-2.26a7,7,0,0,0,.56-6.34,7,7,0,0,1-4.55,2.28,5.93,5.93,0,0,1-5.64-3.25c-1.3-2.13-1.5-7.83-.92-10.81s1.83-6.95,2.58-7.91c0,0,.08,4.44,2.46,7.28s4.12,3.77,6.45,4.19,4.52-1.43,4.52-3a3.33,3.33,0,0,0-2.14-3.42c-1.55-.68-3.56.45-3.56.45s-2.48.71-4.19-2.48-.08-8.66-.08-8.66,1.38-3.59,2.79-4.79a28.28,28.28,0,0,0,5.12-6,28.69,28.69,0,0,0,1.58-3.58,34.67,34.67,0,0,0,2.89,4.89c1.23,1.5,7.53,8,9.18,12.15s1,6.12.55,7.22a4.36,4.36,0,0,1-3.21,2.44c-1.5.25-3.71-.3-3.81-2.64a3.08,3.08,0,0,0,3.59,1.76c2.73-.5,2.43-3.89,2.1-4.72a5.21,5.21,0,0,0-4-3.36,5.57,5.57,0,0,0-5.64,2.28,7.15,7.15,0,0,0-.28,7.05,8.25,8.25,0,0,0,7.65,4.12,9.35,9.35,0,0,0,8.39-6.17,13.2,13.2,0,0,0,.45-6.13,40.53,40.53,0,0,0,7,3.22,14,14,0,0,1,8.58,6.17c2.09,3.59.2,7.78-2.08,9.54a8.06,8.06,0,0,1-10-.26,5.56,5.56,0,0,1-.58-8c1-.9,1.81-1.61,4.42-1.23s1.6,3.59.2,4.09a1.63,1.63,0,0,0-.88,2.41,2.4,2.4,0,0,0,3.16.4c1.48-.85,3.31-2.46,3.19-4.77a7.2,7.2,0,0,0-4.22-5.64,8.16,8.16,0,0,0-7.35.47c-2,1.43-4.07,3.47-4.47,6.38a11.07,11.07,0,0,0,3.21,8.46c1.91,1.7,3.39,3.25,8.11,3.51,3.26.17,6.43-2.13,6.43-2.13a20.59,20.59,0,0,0,1.48,7.4c1.45,3.06,4.29,7.6,5,10.19a7.8,7.8,0,0,1-.35,5.77,3.66,3.66,0,0,1-3.77,1.76,4.33,4.33,0,0,1-3.23-2.71c-.3-.78-.05-2.61.78-3.14a2.58,2.58,0,0,1,2.68-.63,1.48,1.48,0,0,1,.85,2.39,1.32,1.32,0,0,1-.7-.2,1.18,1.18,0,0,0-1.63.25c-.53.7.2,1.5.2,1.5a3.73,3.73,0,0,0,2.46.53,2.92,2.92,0,0,0,2-2.71,4.25,4.25,0,0,0-2.09-3.64,4.76,4.76,0,0,0-5.37.68,6,6,0,0,0-1.38,4.14,2.57,2.57,0,0,0-1.33,2.81s.35-1.11,1-1.23.75.25,1,1.1,2.2,3.47,4.71,3.67,5-1.31,5.73-2.86a8.92,8.92,0,0,0,1.1-4.9,8.73,8.73,0,0,1,3.39,1.48c1.2,1.06,2.76,2,3,3.89a6.08,6.08,0,0,1-1.38,3.84s.83,2.44,2.71,2,1.91-3.39,1.76-3.94a6.51,6.51,0,0,0,5.32,2.93,3.93,3.93,0,0,0,3.66-3.44,3.08,3.08,0,0,0-3.46-3.63,2.55,2.55,0,0,0-1.88,2.76c.05,2,2.43,1.83,2.78,1.45a1.37,1.37,0,0,0-.05-2,1.34,1.34,0,0,1,.43,2c-.78,1.38-2.76.77-3.74.15a15.6,15.6,0,0,1-3-3.27,16.72,16.72,0,0,0-2.49-2.33,8.59,8.59,0,0,0,6.9-6.2c1.54-5.54-2.71-8.83-4.21-9.71s-4.62-1.26-6.53-.05a6.6,6.6,0,0,0-3.39,6.57c.21,3.64,4.5,5,5.6,4.52a4.15,4.15,0,0,0,3-3.19c.68-2.3-2.06-2.45-2.31-1.55s-.78,2.41-2.39,1.68-1-3.86-.07-4.37,1.25-1.87,4.77-.77c2.18.67,4.82,5.34.68,9.43-2.87,2.83-7.73.33-9.11-1.71s-5.25-8.8-5.7-12.12a23,23,0,0,1,.88-9.56,17.78,17.78,0,0,0,.93-4.49,22.07,22.07,0,0,0,3.94,3c1.65.82,4.36,2.4,5.37,4.16s.85,2.94.22,3.77a2.42,2.42,0,0,1-1.85.9,1,1,0,0,1-1.21-.68s1.34,1.44,2.76-.5c.55-.75-.45-3-1.88-3.16s-3,.4-3.54,1.3-.88,3,.23,4.07,1.95,1.72,4.74,1.5c1.93-.15,4.74-2.81,3.66-6.72a8.6,8.6,0,0,0-4.74-5.45,5.83,5.83,0,0,0,4.42-1.88c1.83-2.06-.68-3.84-1.28-4.09a8.34,8.34,0,0,0-1.48-.4s-2.39,2.48-4.57,2.58a6.94,6.94,0,0,1-4.92-2.08s2.42,1.77,6-.18c2.56-1.38,2.11-3.89.76-4.49a1.74,1.74,0,0,0-2.21,1.18c-.08.5.15,1.13,0,1.53s-.62,1.36-2.28,1.13a7.41,7.41,0,0,1-4.29-1.5,6.72,6.72,0,0,1-1.88-3.19,10,10,0,0,0,5.64-1.86,8.13,8.13,0,0,0,3.69-6.5,8.42,8.42,0,0,0-2.71-6.2c-1.63-1.33-6.3-4.11-8.46-6.57s-3.23-3.37-3.33-6a3.76,3.76,0,0,1,2.88-3.77,2,2,0,0,1,2.24.63,2.63,2.63,0,0,0-3.95,1.23c-1,1.93,1,4.44,2.92,4.64a6,6,0,0,0,5.27-2.33,5.47,5.47,0,0,0-.23-5.9,7.47,7.47,0,0,0-5.47-2.86c-3-.15-5.55,2.09-6.55,3.47a8.41,8.41,0,0,0-.9,6.77c.75,2.64,3.56,6.4,7.35,8.66,0,0-3.89,1.08-4.87,3.66a6.77,6.77,0,0,0,1.13,6.63,5.31,5.31,0,0,0,6.6,1.13c3.06-1.53.95-6.1-.1-6.1s-1.71.25-2,.95.37,1.66.85,2.31c0,0-.48,1.56-2.36.58s-1.55-3.79-1-4.39,2-2.36,3.89-2.06,3.79,1.1,4.57,3.16a5.24,5.24,0,0,1-1.2,5.88c-1.66,1.38-4.85,2.48-9.29,1.75a19.06,19.06,0,0,1-9.74-4.34,12.13,12.13,0,0,1-3.71-5.55s5.59,1.13,7.88-2.61-1.76-7.42-3.34-7.9c0,0,.58,3.31-2,5.09s-6.77.18-8.66-1.08a15.39,15.39,0,0,1-4.91-4.89c-1.06-1.91-3.07-5.37-3.74-8.11s-1.31-4.11-1.26-7c0,0,4.47,1.21,7.58.4s5.82-1.48,8.51-4.36c1.7-1.83,3.51-4.5,6.15-6s3.69-2.08,6.7-1.35,3.81,3.94,3.74,5.9-2.21,4.64-4.34,4.81a4.27,4.27,0,0,1-4.4-2.46,3,3,0,0,1,1-3.46,1.43,1.43,0,0,1,2.11.75c.38.91,0,1.41.7,1.54s1.83-.16,2.06-.86a4,4,0,0,0-6.78-3.49,6.11,6.11,0,0,0-1.93,7,6.47,6.47,0,0,0,5.65,4.31,9.08,9.08,0,0,0,4.74-1.15,3.72,3.72,0,0,0,4.43-.18s-2.5.35-2.5-1.4a11.44,11.44,0,0,0,3-5.46,8.39,8.39,0,0,0-3.31-8.15,10.38,10.38,0,0,0-6.37-2,9.35,9.35,0,0,0,3.5-5.7,7.05,7.05,0,0,0-2.91-7.12c-1.83-1.32-5.74-2.88-6.74-3.88a3.7,3.7,0,0,1-1.28-3.08c.13-1,.56-3,1.75-3.65a3.83,3.83,0,0,1,3.8-.14c1.13.7,1.19,1.79.89,2.06s-.44.92-1.83.52c0,0,0-1.26-.64-1.58a1.63,1.63,0,0,0-2.18.12c-.77.79-.51,2.93.39,3.63s1.31,1.5,4.31,1.2c2.49-.24,4-3.57,3.05-6a5.41,5.41,0,0,0-4.38-3.5c-2.36-.43-5.05.38-6.12,1.54a7.81,7.81,0,0,0-2.3,6.06,7.21,7.21,0,0,0,3.33,6.05,41.66,41.66,0,0,0,4.5,2.39,3.74,3.74,0,0,0-2.61,4.34c.6,3.43,4.93,2.7,5.4,1.81s.9-2,.06-2.8a1.76,1.76,0,0,0-2.28-.23s1.07-1.6,2.76.09-.26,4.71-1.44,5.73a13.41,13.41,0,0,1-5.56,2.46s.38-6.57-6.25-11.5-14.36-2.29-16.32-.58-4.36,4.44-4.19,8.13.26,5.65,3.18,8.53a9.61,9.61,0,0,0,9,2.12,6.13,6.13,0,0,0,4-4.78c.43-2.56-.51-5.08-1.71-5.66s-2.94-.36-3.54.62a4.39,4.39,0,0,0,.06,4.53s-2.17,2.41-4.56-.5a5.55,5.55,0,0,1,.13-7.1,6.86,6.86,0,0,1,6.23-2.77c3.9.21,7.74,4.11,8.1,6.72s1,4.9-2,9.11-11.82,3.84-15.47,1.09-7.17-6.24-8.64-10.89-1.79-6.89-.92-10.92,4.76-6.76,6.92-6.8,2.75.19,3.22,2.23c0,0,2.2-2.23,1-4.37s-4.48-2.54-6.29-1.73a18,18,0,0,1,5.42-9.3c4.52-4.07,6.84-5.52,11-5.87s6.62,3.14,6.46,5.34a5.88,5.88,0,0,1-3.73,5.57,4.12,4.12,0,0,1-5.57-2.33c-.47-1.3,0-3.24,1-3.73s1.53-.36,2.11.34c0,0-.79,1.88,0,2.56s2.28,1.09,2.93-.77-.5-4.22-1.56-4.65a5.4,5.4,0,0,0-5.46.45,6.48,6.48,0,0,0-2.31,6.7,6.56,6.56,0,0,0,4.06,4.54,9.54,9.54,0,0,0,4.88.19s1.26,2,4.35,1.11c0,0-2.47-.45-2.09-2,0,0,3.18-1.24,5-5.79s-2-8.85-4.31-9.81-5.48-1.94-8.42-.71a12.35,12.35,0,0,1,1.83-6.72c2.15-3.9,4.54-4.31,5.7-4.28a15.52,15.52,0,0,1,4.28,1.19c.45.28,2.76-2.3,2.39-3.46s-.79-2.47-3-2.79a5.07,5.07,0,0,0-3.4.49,9.91,9.91,0,0,0,2.82-7.36c-.34-4.37-3.73-5.42-4.91-5.44s-3.73.3-4.67,1.9-1.37,3.52-.21,4.9a3.79,3.79,0,0,0,4.69.73,2.86,2.86,0,0,0,1-3.31c-.42-.72-2.13-1.9-3.24-.08,0,0,.24-1.86,2.61-1.09s2.11,3.86,1.15,5.59-.69,1.51-3.1,4.31a18.2,18.2,0,0,0-3.17,4.82s-2.39-6.48-8.47-7.72c0,0,.15-2.28,3.09-4.5s6.48-5.64,7.42-7.68a11.49,11.49,0,0,0,.81-7.28A38.22,38.22,0,0,0,335,157.05c-2.61-3-4.59-3.8-5.36-6.1s1.45-4.67,2.44-5.1a3.77,3.77,0,0,1,3.66.53c.81.85,1.14,1.09.86,2.2s-1.75.68-2.07.34c0,0,.28-1.13-.11-1.6a1.76,1.76,0,0,0-2.37-.57c-1.26.64-1,4.11.75,5a5.34,5.34,0,0,0,4.74.45c1.55-.62,2.62-3.23,2.45-4.7a5.63,5.63,0,0,0-1.9-3.52,10.54,10.54,0,0,0-2.56-1.32,4.77,4.77,0,0,0,1.15-5.46,4.24,4.24,0,0,0-6.16-1.8,3.64,3.64,0,0,0-1.07,3.93,2.79,2.79,0,0,0,3,1.83,2.26,2.26,0,0,0,1.58-1.81c.23-1.13-1-1.54-1.3-.89s-.13,1.27-1,1.23-1.06-1.7-.68-2.22a2.2,2.2,0,0,1,3-.76c1.7.78,1.74,3.05,1.17,4.14a3.59,3.59,0,0,1-2.09,1.49s-4.95.1-6.25,4.88.76,7.45,2.51,8.86,3.5,2.64,4.42,4.31c0,0-5.78-1.33-9.45,1.92a7.86,7.86,0,0,0-1.52,10.37c1.75,2.79,5.77,2.88,7.81,2s4.06-2.71,3.74-5.42-1.92-3.35-3.46-2.86a2.54,2.54,0,0,0-1.43,3.33s-3.21,2-3.16-1.85c0-1.58,2.78-3.5,5.93-2.8s4.8,4.1,4.53,7.36-7.3,7.64-8.68,9.67-2.65,3.54-2.86,5.93a10.46,10.46,0,0,0-7.28,3.6S315.87,192.08,315.66,188.13Z",
    transform: "translate(-161.11 -75.11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320,373.51s6.74,1.11,12.48-1.56,6.93-6,6.64-7.93-1.24-3.18-2.65-3.46a3.92,3.92,0,0,0-3.71,1.69C332,363.34,326.57,372.78,320,373.51Z",
    transform: "translate(-161.11 -75.11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M321.58,374.3a19.31,19.31,0,0,0,9.2,4.06c5,.52,7.23-1.29,7.82-2.71s.45-2.69-.4-3.46a3.13,3.13,0,0,0-3.24-.37C334,372.27,326.39,376.5,321.58,374.3Z",
    transform: "translate(-161.11 -75.11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M293.24,364.17a15.13,15.13,0,0,0,2.46,7.48c2.33,3.21,4.53,3.54,5.67,3.14a2.33,2.33,0,0,0,1.81-2.05,2.45,2.45,0,0,0-1.49-2.07C300.93,370.35,294.48,368.13,293.24,364.17Z",
    transform: "translate(-161.11 -75.11)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.68,365.67a11.25,11.25,0,0,0-1.24,5.76c.3,3,1.6,4,2.48,4.17a1.75,1.75,0,0,0,1.95-.64,1.85,1.85,0,0,0-.18-1.91C295.32,372.56,292,368.69,292.68,365.67Z",
    transform: "translate(-161.11 -75.11)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M273.64,392a7.84,7.84,0,0,0-4.07-.59c-2,.35-2.7,1.3-2.78,1.92a1.22,1.22,0,0,0,.54,1.33,1.27,1.27,0,0,0,1.31-.22C269,394.14,271.5,391.64,273.64,392Z",
    transform: "translate(-161.11 -75.11)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291.21,386.08a11.71,11.71,0,0,0,1.27,5.94c1.53,2.65,3.19,3.08,4.09,2.87s1.48-.73,1.56-1.42a1.92,1.92,0,0,0-1-1.72C296.6,391.45,291.84,389.22,291.21,386.08Z",
    transform: "translate(-161.11 -75.11)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291,384.23a15.25,15.25,0,0,0,5.14,6.1c3.41,2.13,5.6,1.6,6.51.8a2.34,2.34,0,0,0,.93-2.61,2.47,2.47,0,0,0-2.18-1.39C300.56,387.12,293.66,387.47,291,384.23Z",
    transform: "translate(-161.11 -75.11)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.59,367a10,10,0,0,1-2,6,7.07,7.07,0,0,1-5.35,2.82c-1.69.15-2.75-.92-2.77-1.54a1.76,1.76,0,0,1,1.28-2c1.34-.47,1.47.38,4.45-.49S283.59,367,283.59,367Z",
    transform: "translate(-161.11 -75.11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.34,370.74a7,7,0,0,1,.32,4.41,4.91,4.91,0,0,1-2.66,3.29,1.69,1.69,0,0,1-2.21-.23,1.22,1.22,0,0,1,.27-1.65c.73-.67,1.05-.16,2.73-1.54S283.34,370.74,283.34,370.74Z",
    transform: "translate(-161.11 -75.11)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.11,385.44a7,7,0,0,1-.45,5.84c-1.65,3.2.38,3.33.57,3.39s2.91-.14,2.26-4.5A8,8,0,0,0,378.11,385.44Z",
    transform: "translate(-161.11 -75.11)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.23,385.94A5.32,5.32,0,0,1,381,390c0,2.73,1.44,2.1,1.58,2.07s1.91-1.12-.08-3.81A6.08,6.08,0,0,0,379.23,385.94Z",
    transform: "translate(-161.11 -75.11)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.42,368.83a8.44,8.44,0,0,1-1.84-6.79c.58-4.28-1.77-3.61-2-3.6s-3.24,1.33-.74,6A9.68,9.68,0,0,0,371.42,368.83Z",
    transform: "translate(-161.11 -75.11)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M394.93,366.4a9.15,9.15,0,0,0-3.8-6.58c-3.74-2.81-1.43-4.11-1.24-4.28s3.49-1.47,5.16,4A10.47,10.47,0,0,1,394.93,366.4Z",
    transform: "translate(-161.11 -75.11)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M375.19,343.7a9.52,9.52,0,0,1-1.68,7.74c-2.81,4-.11,4.53.13,4.64s3.93.36,3.86-5.61A10.88,10.88,0,0,0,375.19,343.7Z",
    transform: "translate(-161.11 -75.11)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M287,351a17.14,17.14,0,0,1-7.46,4.81c-4.32,1.15-6.48-.13-7.19-1.28a2.61,2.61,0,0,1-.13-3.08,2.75,2.75,0,0,1,2.77-.76C275.87,350.93,283.1,353.56,287,351Z",
    transform: "translate(-161.11 -75.11)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286.37,352.76a13,13,0,0,1-3.26,5.93c-2.48,2.33-4.39,2.26-5.29,1.74a2,2,0,0,1-1.2-2,2.09,2.09,0,0,1,1.59-1.51C278.9,356.75,284.7,355.9,286.37,352.76Z",
    transform: "translate(-161.11 -75.11)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M287.52,305.56a15.15,15.15,0,0,0-4,6.77c-.88,3.87.33,5.74,1.38,6.33a2.31,2.31,0,0,0,2.73,0,2.44,2.44,0,0,0,.58-2.48C287.94,315.41,285.36,309.09,287.52,305.56Z",
    transform: "translate(-161.11 -75.11)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.75,304.22a19.3,19.3,0,0,0-.37,10c1.37,4.86,3.86,6.23,5.39,6.25s2.67-.57,3.07-1.65a3.12,3.12,0,0,0-.86-3.14C295.22,315,288.49,309.5,288.75,304.22Z",
    transform: "translate(-161.11 -75.11)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.57,307.67a17,17,0,0,0,.13,8.85c1.43,4.22,3.69,5.31,5,5.25a2.6,2.6,0,0,0,2.63-1.59,2.77,2.77,0,0,0-.9-2.72C325.76,316.86,319.58,312.32,319.57,307.67Z",
    transform: "translate(-161.11 -75.11)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348,326.29a19.55,19.55,0,0,0-7.24-7.21c-4.58-2.34-7.32-1.42-8.4-.29s-1.41,2.38-.89,3.43a3.21,3.21,0,0,0,2.94,1.53C335.46,323.67,344.23,322.45,348,326.29Z",
    transform: "translate(-161.11 -75.11)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M347.7,324.24a15,15,0,0,0-2.11-7.48c-2.16-3.26-4.32-3.67-5.45-3.32s-1.83,1.05-1.87,1.94a2.42,2.42,0,0,0,1.37,2.11C340.38,317.83,346.64,320.29,347.7,324.24Z",
    transform: "translate(-161.11 -75.11)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.48,307.64a17,17,0,0,0,.21,8.91c1.47,4.24,3.74,5.32,5.1,5.25a2.62,2.62,0,0,0,2.64-1.62,2.78,2.78,0,0,0-.93-2.74C325.78,316.85,319.53,312.32,319.48,307.64Z",
    transform: "translate(-161.11 -75.11)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.42,285.31a16.59,16.59,0,0,1-.37,8.67c-1.51,4.09-3.75,5.1-5.07,5a2.54,2.54,0,0,1-2.53-1.63,2.67,2.67,0,0,1,.95-2.64C327.11,294.15,333.29,289.87,333.42,285.31Z",
    transform: "translate(-161.11 -75.11)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.64,287a12.46,12.46,0,0,1,2.86,5.81c.47,3.22-.63,4.68-1.53,5.09a1.89,1.89,0,0,1-2.24-.16,2,2,0,0,1-.32-2.07C333.67,295,336.18,290,334.64,287Z",
    transform: "translate(-161.11 -75.11)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M375.38,290.2a13.43,13.43,0,0,0-2.34-6.6c-2.13-2.8-4.1-3-5.1-2.66a2,2,0,0,0-1.56,1.85,2.15,2.15,0,0,0,1.36,1.81C368.42,284.87,374.2,286.71,375.38,290.2Z",
    transform: "translate(-161.11 -75.11)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M375.66,288.69a9.49,9.49,0,0,0-2.08-5c-1.83-2-2.22-2.66-1.83-3.8s1.91-.72,2.34-.21S376.67,282.22,375.66,288.69Z",
    transform: "translate(-161.11 -75.11)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.32,268.09a18.18,18.18,0,0,0,4.53,8.31c3.46,3.29,6.13,3.2,7.39,2.48a2.8,2.8,0,0,0,1.7-2.81,3,3,0,0,0-2.21-2.14C343.76,273.72,335.64,272.49,333.32,268.09Z",
    transform: "translate(-161.11 -75.11)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332.66,265.7s4.41,5,10.4,6.53,9-.27,9.93-1.89,1-3.17.13-4.26a3.83,3.83,0,0,0-3.85-1C348,265.45,338.09,269.21,332.66,265.7Z",
    transform: "translate(-161.11 -75.11)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359.68,248.82a8.79,8.79,0,0,0,4.09-2c1.65-1.57,1.67-2.85,1.36-3.47a1.35,1.35,0,0,0-1.3-.88,1.43,1.43,0,0,0-1.08,1C362.63,244,361.84,247.81,359.68,248.82Z",
    transform: "translate(-161.11 -75.11)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M321,263.79s-1.36-6-6.1-8.81-8.13-1.84-9.86-1a2.73,2.73,0,0,0-1.58,3.54c.49,1.05,1.43,2,3.91,1.35S315.21,256.34,321,263.79Z",
    transform: "translate(-161.11 -75.11)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.46,259.09s-1.82-4.27-.16-8.06,4.15-4.7,5.57-5a2,2,0,0,1,2.52,1.46c.17.86,0,1.85-1.79,2.55S300.69,252,300.46,259.09Z",
    transform: "translate(-161.11 -75.11)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.24,235.58a10.61,10.61,0,0,0-1.85-5.21c-1.69-2.22-3.24-2.41-4-2.11a1.63,1.63,0,0,0-1.24,1.47,1.71,1.71,0,0,0,1.08,1.43C308.74,231.37,313.3,232.82,314.24,235.58Z",
    transform: "translate(-161.11 -75.11)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.84,233.9a7.07,7.07,0,0,0,1.2-3.51c0-1.86-.71-2.61-1.25-2.78a1.1,1.1,0,0,0-1.26.25,1.19,1.19,0,0,0,0,1.21C313.7,229.4,315.5,232.07,314.84,233.9Z",
    transform: "translate(-161.11 -75.11)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.51,234.19a12.67,12.67,0,0,1,1.47-6.41c1.7-2.84,3.5-3.28,4.48-3s1.59.82,1.66,1.57a2,2,0,0,1-1.08,1.84C336.43,228.47,331.24,230.81,330.51,234.19Z",
    transform: "translate(-161.11 -75.11)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.68,235.7a15.92,15.92,0,0,1,5.57-6.15c3.62-2.09,5.88-1.46,6.8-.58a2.42,2.42,0,0,1,.86,2.74,2.56,2.56,0,0,1-2.32,1.36C340.73,233.06,333.57,232.43,330.68,235.7Z",
    transform: "translate(-161.11 -75.11)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.9,222.32a15.53,15.53,0,0,0,6.2-5.23c2.17-3.46,1.63-5.69.81-6.62a2.37,2.37,0,0,0-2.65-.94,2.51,2.51,0,0,0-1.41,2.22C351.83,212.6,352.2,219.61,348.9,222.32Z",
    transform: "translate(-161.11 -75.11)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.36,203.94a12.84,12.84,0,0,1,4.42-5c2.89-1.71,4.71-1.23,5.46-.54a2,2,0,0,1,.72,2.2,2,2,0,0,1-1.85,1.12C347.41,201.72,341.65,201.28,339.36,203.94Z",
    transform: "translate(-161.11 -75.11)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M338.78,205.37a16.2,16.2,0,0,1,8-2.78c4.23-.11,5.94,1.55,6.34,2.77a2.48,2.48,0,0,1-.56,2.87,2.63,2.63,0,0,1-2.73.09C349,207.88,342.94,203.85,338.78,205.37Z",
    transform: "translate(-161.11 -75.11)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M338.37,195.44a7.83,7.83,0,0,0,.82-5.51c-.8-2.74-2.42-3.59-3.37-3.89a1.41,1.41,0,0,0-1.86.77c-.19.58-.17,1.27,1,1.91S338.84,190.56,338.37,195.44Z",
    transform: "translate(-161.11 -75.11)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.44,192.89a4.1,4.1,0,0,0,1.5-2.5,2.73,2.73,0,0,0-.86-2.56.74.74,0,0,0-1.05,0c-.21.24-.33.58.1,1.12S340.64,190.63,339.44,192.89Z",
    transform: "translate(-161.11 -75.11)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M324.92,187.29s-2.44-2.73-2.15-6,1.91-4.56,2.9-5.11a1.61,1.61,0,0,1,2.25.45c.34.6.47,1.38-.69,2.36S323.31,182,324.92,187.29Z",
    transform: "translate(-161.11 -75.11)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.92,187.59a6.87,6.87,0,0,1-4.15-2.58,4.59,4.59,0,0,1-.69-4.46,1.25,1.25,0,0,1,1.58-.8c.49.2.94.6.7,1.75S320.4,185.14,323.92,187.59Z",
    transform: "translate(-161.11 -75.11)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M338.72,162.88a9.42,9.42,0,0,0,.85-4.84c-.34-2.45-1.46-3.28-2.2-3.39a1.45,1.45,0,0,0-1.6.6,1.49,1.49,0,0,0,.21,1.57C336.3,157.22,339.2,160.34,338.72,162.88Z",
    transform: "translate(-161.11 -75.11)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.33,162.24a7.4,7.4,0,0,0,2.48-3c.74-1.81.3-2.81-.16-3.18a1.15,1.15,0,0,0-1.33-.23,1.22,1.22,0,0,0-.48,1.16C339.91,157.43,340.65,160.7,339.33,162.24Z",
    transform: "translate(-161.11 -75.11)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 106.54,
    cy: 306.88,
    r: 2.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108.82,
    cy: 299.4,
    r: 2.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.71,
    cy: 318.07,
    r: 1.87
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.27,
    cy: 302.75,
    r: 2.21
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.86,
    cy: 296.16,
    r: 1.72
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.13,
    cy: 291.87,
    r: 1.32
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.63,
    cy: 289.79,
    r: 1.07
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 212.78,
    cy: 317.08,
    r: 2.48
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 213.62,
    cy: 309.49,
    r: 1.87
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 211.54,
    cy: 303.31,
    r: 1.24
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 208.65,
    cy: 299.23,
    r: 1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 222.9,
    cy: 305.01,
    r: 1.46
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.05,
    cy: 306.01,
    r: 1.33
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 232.19,
    cy: 305.31,
    r: 0.95
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 211.39,
    cy: 286.52,
    r: 1.69
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.16,
    cy: 283.23,
    r: 1.32
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 220.96,
    cy: 281.98,
    r: 0.97
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.5,
    cy: 282.32,
    r: 1.52
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.84,
    cy: 276.9,
    r: 1.86
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.32,
    cy: 271.69,
    r: 2.18
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.21,
    cy: 264.73,
    r: 1.43
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.46,
    cy: 259.72,
    r: 1.97
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.57,
    cy: 252.74,
    r: 1.86
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 197.64,
    cy: 252.85,
    r: 1.45
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.25,
    cy: 255.13,
    r: 1.09
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.15,
    cy: 257.95,
    r: 0.87
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.01,
    cy: 263.75,
    r: 0.98
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.29,
    cy: 260.75,
    r: 1.19
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.75,
    cy: 258.58,
    r: 1.66
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.59,
    cy: 259.04,
    r: 2.12
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.93,
    cy: 252.57,
    r: 0.96
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.21,
    cy: 248.26,
    r: 1.24
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 211.5,
    cy: 243.86,
    r: 1.57
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 149.72,
    cy: 235.31,
    r: 1.78
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.06,
    cy: 228.87,
    r: 2.32
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.22,
    cy: 228.35,
    r: 1.79
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 129.02,
    cy: 221.38,
    r: 2.28
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 130.85,
    cy: 213.74,
    r: 1.83
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.98,
    cy: 196.63,
    r: 3.24
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.84,
    cy: 203.08,
    r: 2.32
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.27,
    cy: 209.9,
    r: 1.75
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.23,
    cy: 210.76,
    r: 1.41
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.4,
    cy: 208.07,
    r: 0.87
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.3,
    cy: 218.45,
    r: 1.81
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 195.82,
    cy: 222.21,
    r: 1.41
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.84,
    cy: 224.47,
    r: 1.05
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.45,
    cy: 200.68,
    r: 1.51
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.32,
    cy: 196.8,
    r: 1.93
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.71,
    cy: 179.15,
    r: 1.15
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.67,
    cy: 173.52,
    r: 1.25
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.53,
    cy: 169.27,
    r: 1.27
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.83,
    cy: 168.79,
    r: 1.14
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.56,
    cy: 173.2,
    r: 1.23
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.46,
    cy: 177.79,
    r: 0.95
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.85,
    cy: 173.67,
    r: 1.41
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.6,
    cy: 168.35,
    r: 1.96
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.91,
    cy: 167.47,
    r: 1.93
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.3,
    cy: 159.49,
    r: 1.93
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.25,
    cy: 162.98,
    r: 1.46
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.51,
    cy: 147.17,
    r: 1.46
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.3,
    cy: 143.43,
    r: 1.83
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.31,
    cy: 138.77,
    r: 0.93
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.8,
    cy: 136.41,
    r: 1.43
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.51,
    cy: 134.52,
    r: 2.42
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.11,
    cy: 99.63,
    r: 2.37
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.04,
    cy: 94.12,
    r: 1.38
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.55,
    cy: 90.34,
    r: 0.99
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.34,
    cy: 82.24,
    r: 2.24
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasSwirls);
export default __webpack_public_path__ + "static/media/christmas-swirls.fa28ccf261197eaf9d6f65623cfd1ed7.svg";
export { ForwardRef as ReactComponent };